import { User, UserManager } from "oidc-client-ts";
import { AuthContextProps } from "react-oidc-context";

import { ISwitchReplacementResponse } from "api/replacementsService";

// Zastępstwa: zastosowanie tokenu zwróconego przez POST /replacements/switch.
//
// Token niesie claimy Nota_SwitchedTo* — od tej chwili BE liczy kontekst pracy
// (UserId) jako zastępowanego, a tożsamość zalogowanego zostaje w `sub` (OrginalUserId).
// Ten sam zabieg co przy rejestracji/zaproszeniu (registerModule, InvitationModule):
// storeUser z gołym tokenem + signinSilent (refresh dogrywa profil). Potem PEŁNE
// przeładowanie — konteksty (listy, liczniki, klucze, SignalR) trzymają dane per konto
// i nie mają ścieżki „zmień użytkownika w locie".
export const applyReplacementSwitch = async (
  auth: AuthContextProps,
  response: ISwitchReplacementResponse,
) => {
  const userManager = new UserManager(auth.settings);

  // Migawka bieżącego usera — jeśli IdP odrzuci nowy refresh token, wracamy do niej,
  // zamiast zostawić w storage „gołego" usera (sub: "", bez expires_at), z którym
  // AuthProvider uznałby sesję za ważną i apka działałaby z pustym userId.
  const previous = await userManager.getUser();

  await userManager.storeUser(
    new User({
      access_token: response.AccessToken,
      refresh_token: response.RefreshToken,
      token_type: "Bearer",
      // Bez expires_at AuthProvider nie umiał ocenić ważności sesji (expired === undefined).
      expires_at: Math.floor(Date.now() / 1000) + (response.ExpiresIn || 0),
      profile: { sub: "", iss: "", aud: "", exp: 0, iat: 0 },
    }),
  );

  // signinSilent z react-oidc-context NIE rzuca — po błędzie zwraca null (błąd idzie do
  // stanu AuthProvidera). Brak usera = przełączenie się nie udało.
  const refreshed = await auth.signinSilent();
  if (!refreshed) {
    if (previous) await userManager.storeUser(previous);
    else await userManager.removeUser();
    throw new Error("Nie udało się odświeżyć sesji po przełączeniu konta.");
  }

  window.location.replace("/home");
};
